export default "/images/d0de5350a3a6c64677505249aa5b447e.jpg";